
import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle, RefreshCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface FamilyErrorStateProps {
  error: string;
  onRetry: () => void;
}

const FamilyErrorState = ({ error, onRetry }: FamilyErrorStateProps) => {
  return (
    <Alert variant="destructive" className="mb-4">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription className="flex flex-col gap-2">
        <p>{error}</p>
        <Button 
          onClick={onRetry} 
          variant="outline" 
          size="sm" 
          className="self-start flex items-center gap-2"
        >
          <RefreshCcw className="h-3.5 w-3.5" />
          Retry
        </Button>
      </AlertDescription>
    </Alert>
  );
};

export default FamilyErrorState;
